import React from 'react';
import {HexColor} from '../../@types/colors';
import classnames from '../../helpers/classnames';

export default function OrderStatusRepresentation(props: {
    label?: string,
    children?: React.ReactNode,
    bgColor?: HexColor | null,
    textColor?: HexColor | null,
    tag?: string,
} & React.HTMLProps<HTMLElement>) {
    const {bgColor, textColor, tag = 'span', children, label, ...rest} = props;
    const Tag: any = tag ?? 'span';

    return <Tag
            {...rest}
            className={classnames('badge', rest.className)}
            style={{
                color: textColor ?? 'inherit',
                background: bgColor ?? 'inherit',
                ...(rest.style ?? {})
            }}
    >{children ?? label}</Tag>;
}
